import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Alert
} from "react-bootstrap";
import { motion } from "framer-motion";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaInstagram,
  FaTwitter,
  FaLinkedin,
  FaYoutube
} from "react-icons/fa";
import api from '../api/axiosInstance';

const ContactSection = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState(null);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await api.post("/contact", form);

      setStatus({ type: "success", text: res.data.message });
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      setStatus({
        type: "danger",
        text: err.response?.data?.message || "Mesaj gönderilemedi.",
      });
    }
  };

  return (
    <section
      id="contact"
      className="py-5"
      // BURADA DA TEMİZLİK YAPTIK
      style={{
        backgroundColor: "#E7F5F2",
        position: "relative",
      }}
    >
      <Container>
        <motion.div
          className="text-center mb-5"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <h2 className="fw-bold" style={{ color: "#2D8A7A" }}>
            İletişim
          </h2>
          <p className="text-muted lead">
            Bizimle iletişime geçin — önerileriniz, sorularınız veya katkılarınız için.
          </p>
        </motion.div>

        <Row className="align-items-center g-4">
          {/* FORM ALANI */}
          <Col md={6}>
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
              className="p-4 bg-white rounded-4 shadow-sm"
            >
              {status && <Alert variant={status.type}>{status.text}</Alert>}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Ad Soyad</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Adınızı ve soyadınızı girin"
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>E-posta</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="ornek@majistralapp.com"
                    value={form.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Mesajınız</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="message"
                    placeholder="Mesajınızı buraya yazın..."
                    value={form.message}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Button
                  variant="primary"
                  type="submit"
                  size="lg"
                  className="w-100"
                  style={{
                    backgroundColor: "#2D8A7A",
                    borderColor: "#2D8A7A",
                  }}
                >
                  Gönder
                </Button>
              </Form>
            </motion.div>
          </Col>

          {/* SOSYAL MEDYA + İLETİŞİM BİLGİLERİ */}
          <Col md={6}>
            <motion.div
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
              className="ps-md-4 text-center text-md-start"
            >
              <h5 className="fw-bold mb-3" style={{ color: "#2D8A7A" }}>
                Sosyal Medyada Biz
              </h5>
              <p className="text-muted mb-4">
                Majistral App topluluğuna katılın ve en güncel içeriklerden haberdar olun.
              </p>

              <div className="d-flex justify-content-center justify-content-md-start gap-3">
                <a
                  href="https://instagram.com/majistralapp"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon instagram"
                >
                  <FaInstagram />
                </a>
                <a
                  href="https://twitter.com/majistralapp"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon twitter"
                >
                  <FaTwitter />
                </a>
                <a
                  href="https://linkedin.com/company/majistralapp"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon linkedin"
                >
                  <FaLinkedin />
                </a>
                <a
                  href="https://youtube.com/@majistralapp"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon youtube"
                >
                  <FaYoutube />
                </a>
              </div>

              <div className="mt-4">
                <p className="text-muted">
                  <FaEnvelope className="me-2" />
                  info@majistralapp.com
                </p>
                <p className="text-muted">
                  <FaPhoneAlt className="me-2" />
                  +90 (500) 000 00 00
                </p>
              </div>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ContactSection;